import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute } from '@angular/router';
import { ConcursoApiService } from '../services/concurso-api.service';
import { FiltroConcurso } from './filtro';
import { MessageService } from 'primeng/api';

@Component({
	selector: 'sgp-pesquisar-concurso',
	templateUrl: './pesquisar-concurso.component.html',
	providers: [MessageService]
})
export class PesquisarConcursoComponent implements OnInit, AfterViewInit, OnChanges {
	@Input() labelNome? = 'Nome';
	@Input() pesquisaAoCarregar? = false;
	@Input() limparFormulario? = false;
	@Output() filtrosPesquisa: EventEmitter<FiltroConcurso> = new EventEmitter<FiltroConcurso>();
	@Output() executarLimpar: EventEmitter<boolean> = new EventEmitter<boolean>();
	@ViewChild('elTextoPesquisa') elTextoPesquisa!: ElementRef;

	formGroup!: FormGroup<any>;
	textoPesquisa!: string;
	codigoPesquisa!: string;
	situacao!: string;
	utiliza_perfil = false;
	resultado: any[] = [];

	constructor(protected tabelaService: ConcursoApiService, private fb: FormBuilder) {}

	ngOnChanges(): void {
		if (this.limparFormulario) {
			this.resetarFormulario();
		}
	}

	ngOnInit(): void {
		this.formGroup = this.fb.group({
			textoPesquisa: [''],
			situacao: [''],
			codigoPesquisa: [''],
			utiliza_perfil: [false]
		});
		this.resetarFormulario();
		this.carregarCombos();
		if (this.pesquisaAoCarregar) {
			this.pesquisar();
		}
	}

	private carregarCombos() {
		if (!this.tabelaService.situacoes$) {
			this.tabelaService.listarSituacoes();
		}
	}

	ngAfterViewInit(): void {
		this.elTextoPesquisa.nativeElement.focus();
	}

	pesquisar() {
		const filtro = new FiltroConcurso();
		filtro.nome = this.textoPesquisa;
		filtro.codigo = this.codigoPesquisa;
		filtro.utiliza_perfil = this.utiliza_perfil;
		filtro.situacao = this.situacao;
		this.filtrosPesquisa.emit(filtro);
	}

	limpar() {
		this.resetarFormulario();
		this.elTextoPesquisa.nativeElement.focus();
		this.executarLimpar.emit(true);
	}

	private resetarFormulario() {
		this.textoPesquisa = '';
		this.codigoPesquisa = '';
		this.situacao = '';
		this.utiliza_perfil = false;
		this.limparFormulario = false;
	}
}
